<template>
  <div class="page-header-index-wide">
    <div style="background:#87d068;color:white;line-height:45px;height:45px;width:100%">
      <span style="margin-left:40px">Unit 1 Good morning!</span>
      <router-link :to="{ name: 'AIHearsay' }">
        <div style="float:right;background:#87d068;color:white;line-height:45px;height:45px;margin-right:40px" @click="$refs.table.refresh(true)"><a-icon type="double-left" />  返回</div>
      </router-link>
    </div>

    <a-card :loading="loading" :body-style="{ padding: '30px 60px 40px' }" :style="{ marginTop: '0px'}" :bordered="false">

      <a-row :gutter="12">
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>
        <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginBottom: '10px',background: '#f0f2f5' }" :bordered="false">
            <div class="chart-card-header">
              <div class="meta">
                <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
              </div>
            </div>
            <div class="chart-card-content">
              <div class="content-fix">
                <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>

              </div>
            </div>
            <div class="chart-card-content2">
              <div style="float: right;height:46px;line-height:3;width:50%;max-width:50%;overflow:hidden:padding-top:20px">
                <router-link :to="{ name: 'Repeat' }">
                  <a-button style="background:#87d068;color:white">开始练习</a-button>
                </router-link>
              </div>
            </div>
            <div class="chart-card-footer">

              <div class="field">
                <slot name="footer">未练习</slot>
              </div>
            </div>
          </a-card>
        </a-col>

      <!-- <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card :loading="loading" :bordered="false" title="Section 1a and 1b" :style="{ marginTop: '24px' }">

          <div style="line-height:1.5;margin-bottom:20px;width:100%;max-width:100%;overflow:hidden">Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!
            <div style="float:right;line-height:1.5;width:15%;max-width:20%;overflow:hidden:padding-top:20px"><a-button style="background:green;color:white" @click="$refs.table.refresh(true)">开始练习</a-button></div>
          </div>

          <span class="foot" style="color:green">未练习</span>
        </a-card>

      </a-col> -->
      <!-- <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
        <a-card :loading="loading" :body-style="{ padding: '20px 60px 20px' }" :style="{ marginTop: '24px' }" :bordered="false">
          <div class="chart-card-header">
            <div class="meta">
              <span class="chart-card-title" style="font-size:20px; font-weight: 500;"><a-tag color="blue">对话</a-tag>Section 1a and 1b</span>
            </div>
          </div>
          <div class="chart-card-content">
            <div class="content-fix">
              <slot>Good marning.Helen! Hi Bob! Good marning.Helen! Hi Alice! Good marning.Helen! Hi Cindy!</slot>
              <div style="float:right;line-height:1.5;width:15%;max-width:20%;overflow:hidden:padding-top:20px"><a-button style="background:#87d068;color:white" @click="$refs.table.refresh(true)">开始练习</a-button></div>
            </div>
          </div>
          <div class="chart-card-footer">
            <div class="field">
              <slot name="footer">未练习</slot>
            </div>
          </div>
        </a-card>
      </a-col> -->
      </a-row>
    </a-card>
  </div>
</template>

<script>
import ChartCard from '@/components/chart/ChartCard'
import ACol from 'ant-design-vue/es/grid/Col'
import ATooltip from 'ant-design-vue/es/tooltip/Tooltip'
import Bar from '@/components/chart/Bar'
import Trend from '@/components/Trend'

export default {
  name: 'Analysis',
  components: {
    ATooltip,
    ACol,
    ChartCard,
    Bar,
    Trend
  },
  data () {
    return {
      loading: true
    }
  },
  created () {
    setTimeout(() => {
      this.loading = !this.loading
    }, 1000)
  }
}
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }
  .foot{
      line-height:1.5;
  }
  .chart-card-header {
    position: relative;
    overflow: hidden;
    width: 100%;

    .meta {
      position: relative;
      overflow: hidden;
      width: 100%;
      color: rgba(0, 0, 0, .45);
      font-size: 14px;
      line-height: 22px;
    }
  }

  .chart-card-action {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
  }

  .chart-card-footer {
    color:green;
    margin-bottom: 4px;

    > * {
      position: relative;
    }

    .field {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin: 0;
    }
  }

  .chart-card-content {
      height:46px;
    margin-bottom: 24px;
    position: relative;
    width: 70%;
    display: inline-block;
    overflow: hidden;/*内容超出后隐藏*/
    text-overflow: ellipsis;/* 超出内容显示为省略号*/
    white-space: nowrap;/*文本不进行换行*/
	text-overflow:ellipsis;
    .content-fix {
        overflow:hidden;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
.chart-card-content2 {

    margin-top: 16px;
    float: right;
    margin-bottom: 12px;
    position: relative;
    height: 46px;
    width: 20%;
    display: block;
	white-space: nowrap;
	overflow: hidden;
	text-overflow:ellipsis;
    .content-fix {
        overflow:hidden;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
    }
  }
  .total {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: nowrap;
    color: #000;
    margin-top: 4px;
    margin-bottom: 0;
    font-size: 30px;
    line-height: 38px;
    height: 38px;
  }
</style>
